"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Payment = void 0;
const PostPaymentCreate_1 = require("./PostPaymentCreate");
const PostNotifyFromPayU_1 = require("./PostNotifyFromPayU");
__exportStar(require("./PostPaymentCreate"), exports);
__exportStar(require("./PostNotifyFromPayU"), exports);
exports.Payment = {
    PostCreate: PostPaymentCreate_1.PostPaymentCreate,
    PostNotifyFromPayU: PostNotifyFromPayU_1.PostPaymentNotifyFromPayU
};
//# sourceMappingURL=index.js.map